// src/components/AdminTabPICArea.js
import React, { useEffect, useState } from "react";
import TabTwoColumnLayout from "../layouts/TabTwoColumnLayout";
import { apiFetch } from "../utils/wkCommon";
import AdminListItem from "../components/AdminListItem";

export default function AdminTabPICArea() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const resp = await apiFetch("/api/areas?populate[0]=region&populate[1]=PIC_Area&sort=name:asc");
        if (!mounted) return;
        setItems(resp?.data || []);
      } catch (e) {
        console.error(e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => (mounted = false);
  }, []);

  const filtered = items.filter((it) => {
    const a = it.attributes || it;
    const text = `${a.code || ""} ${a.shortname || ""} ${a.name || ""} ${a.region?.data?.attributes?.name || ""}`.toLowerCase();
    return text.includes((q || "").toLowerCase());
  });

  const leftControls = (
    <>
      <input placeholder="Search code/shortname/name/region..." value={q} onChange={(e) => setQ(e.target.value)} />
      <button onClick={() => {/* create new area */}}>+ New</button>
    </>
  );

  const leftList = (
    <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
      {loading ? <li>Loading…</li> : filtered.map((it) => {
        const a = it.attributes || it;
        const title = a.shortname || a.code || "—";
        const regionName = a.region?.data?.attributes?.name || "";
        const subtitle = `${a.name || ""} ${regionName ? `— ${regionName}` : ""}`;
        return (
          <AdminListItem
            key={it.id}
            title={title}
            subtitle={subtitle}
            active={selected?.id === it.id}
            onClick={() => setSelected(it)}
          />
        );
      })}
    </ul>
  );

  const rightForm = selected ? (
    <div>
      <h3>{selected.attributes?.name}</h3>
      <div>
        <label>Code</label>
        <input defaultValue={selected.attributes?.code || ""} />
      </div>
      <div>
        <label>Shortname</label>
        <input defaultValue={selected.attributes?.shortname || ""} />
      </div>
      <div>
        <label>Region</label>
        <input defaultValue={selected.attributes?.region?.data?.attributes?.name || ""} readOnly />
      </div>
      <div>
        <label>PIC Area</label>
        <div>{/* here you can render linked umat list */}</div>
      </div>
      <div style={{ marginTop: "0.75rem" }}>
        <button>Save</button>
      </div>
    </div>
  ) : (
    <div>Pilih PIC Area dari kiri.</div>
  );

  return <TabTwoColumnLayout leftControls={leftControls} leftList={leftList} rightForm={rightForm} />;
}
